import { Prisma } from "@prisma/client";

import { prisma } from "@/lib/prisma";

export async function getScientificWorkByApplicationId(applicationId: string) {
  return await prisma.applicantScientificWork.findMany({
    where: {
      applicant: {
        Application: {
          every: {
            id: applicationId,
          },
        },
      },
    },
    orderBy: { sortOrder: Prisma.SortOrder.asc },
  });
}
